import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Salesunit } from './salesunit.model';
import { SalesunitPopupService } from './salesunit-popup.service';
import { SalesunitService } from './salesunit.service';

@Component({
    selector: 'jhi-salesunit-delete-dialog',
    templateUrl: './salesunit-delete-dialog.component.html'
})
export class SalesunitDeleteDialogComponent {

    salesunit: Salesunit;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private salesunitService: SalesunitService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['salesunit']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.salesunitService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'salesunitListModification',
                content: 'Deleted an salesunit'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-salesunit-delete-popup',
    template: ''
})
export class SalesunitDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private salesunitPopupService: SalesunitPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.salesunitPopupService
                .open(SalesunitDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/salesunit/salesunit-delete-dialog.component.ts